import { wpApiInstance } from '../api/wp-api';
import { encryptDataTwo } from '../auth/encrypt-data';
import { cognitoError } from '../types/types';

/**
 * Resets the password before the user has signed up
 * 
 * @param {string} key the key
 * @param {string} user the user
 * @param {string} password the password
 * 
 * @returns void
 */
const resetPasswordBeforeSignUp = async (key: string, user: string, password: string) => {
  const resetPasswordForLogin = await wpPassReset(key, user, password);

  if(!resetPasswordForLogin) {
    cognitoError.innerHTML = resetPasswordForLogin;
  }

  location.href = '/member-login';
}

/**
 * Resets the password after the user has signed up
 * 
 * @param {string} key the key
 * @param {string} user the user
 * @param {string} password the password
 * 
 * @returns void
 */
const resetPasswordAfterSignUp = async (key: string, user: string, password: string) => {
  const resetLostPassword = await wpPassReset(key, user, password);

  if(!resetLostPassword) {
    cognitoError.innerHTML = resetLostPassword;
  }

  return resetLostPassword; // This will be used in the ResetLostPassword function
}

/**
 * Resets the password
 * 
 * @param {string} key the key
 * @param {string} user the user
 * @param {string} password the password
 * 
 * @returns response data
 */
const wpPassReset = async (key: string, user: string, password: string) => {
  try {
    const token = encryptDataTwo(`${key}:${user}:${password}`);

    const response = await wpApiInstance.post('/portal/reset', {
      request: token
    }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    const errorArray = ['expired_key', 'invalid_key'];

    if ( errorArray.includes(response.data) ) {
      cognitoError.innerHTML = '';
      cognitoError.innerHTML = 'Error in Siging Up. Please contact Admin for assistance.';
      throw new Error('Error in Siging Up. Please contact Admin for assistance.');
    }

    return response.data;       
  } catch (error: any) {
    console.log('Error in Siging Up. Please contact Admin for assistance.');
    cognitoError.innerHTML = '';
    cognitoError.innerHTML = 'Error in Siging Up. Please contact Admin for assistance.';
    cognitoError.innerHTML = `<p>${error.message}</p>`;
    throw new Error('Error in Siging Up. Please contact Admin for assistance.');
  }  
}

export { resetPasswordBeforeSignUp, resetPasswordAfterSignUp }; 